/**
 * Classe responsável pelas requisições transferir Stops
 * de uma Rota para outra, e resequence.
 *
 * @author: Adalto Junior
 * DATE: 18/04/2013
 *
 */

import { DefaultRequest } from 'scripts/api';

Greenmile.Route = Greenmile.Route || {};
Greenmile.Route.TransferStops = Greenmile.Route.TransferStops || {};
Greenmile.Route.TransferStops.Requests = function () {

    const containersOfListStops = document.querySelectorAll(".transferStop_container .listStops");
    const filterButton = document.querySelector('#transferStopBtnSearchRoute');
    const bestInsertionButton = document.querySelector('#bestInsertion.stopConnect.stopSourceConnect');
    const routeFilteredList = document.querySelector("#stopsRouteFiltered");

    const setListDisplayAndLoadingDisplay = (listDisplay, loadingDisplay) => {
        containersOfListStops.forEach( listStop => {
            const loading = listStop.firstChild;
            const ol = listStop.lastChild;
            ol.style.display = listDisplay;
            loading.style.display = loadingDisplay;
        });
    };

    const toggleFilterSearchButton = () => {
        if(filterButton)
            filterButton.disabled = !filterButton.disabled;
    };

    const isItToShowBestInsertionButton = (boolean) => {
        if (bestInsertionButton && boolean && routeFilteredList.children.length > 1) {
            bestInsertionButton.style.display = 'block';
        } else {
            bestInsertionButton.style.display = 'none';
        }
    };

    const showLoading = function () {
        setListDisplayAndLoadingDisplay('none', 'block');
        toggleFilterSearchButton();
        isItToShowBestInsertionButton(false);
    };

    const hideLoading = function () {
        setListDisplayAndLoadingDisplay('block', 'none');
        toggleFilterSearchButton();
        isItToShowBestInsertionButton(true);
    };

    this.getRouteDataByFilter = function (filter, callback, selector) {

        if (filter) {

            try {
                showLoading();
                const request = new DefaultRequest({
                    method: "post",
                    url: "Route/RetrieveRouteToTransferStops",
                    data: filter,
                    success: function (data) {
                      if (callback) {
                        callback(selector, data);
                      }
                      hideLoading();
                    },
                    error: function () {
                      hideLoading();
                    }
                });
                request.send();
            } catch (e) {

                var error = new Monet.Exception.ReturnError(this, "Error on get route data.", e);
                error.console();

            }

        }

    };

    this.resequenceStops = function (routeId, resequenceStops, callback, selector) {

        if (resequenceStops && routeId) {

            try {

                if (resequenceStops.stopIdList.length > 0) {
                    showLoading();
                    const request = new DefaultRequest({
                        url: "Route/" + routeId + "/SequenceStops",
                        method: "post",
                        data: resequenceStops,
                        success: function (data) {

                            if (callback) {
                                callback(selector, data);
                            }
                            hideLoading();

                        },
                        error: (data) => {
                          hideLoading();
                          const mMessage = new Monet.Form.Messages.AlertMessage();
                          mMessage.setMessage(JSON.parse(data.responseText));
                          mMessage.triggerMessage();
                          this.refreshRouteBySelectorId(selector);
                        }
                    });
                    request.send();

                }

            } catch (e) {

                var error = new Monet.Exception.ReturnError(this, "Problem on request transfer stops.", e);
                error.console();

            }
        }

    };

    this.transferStopsToRoute = function (fromRoute, toRoute, transferStops, callback, selector) {

        if (fromRoute && toRoute && transferStops) {

            try {
                var values;

                values = transferStops;
                values.routeSourceId = fromRoute;
                values.routeTargetId = toRoute;

                showLoading();
                const request = new DefaultRequest({
                    url: "Route/TransferStops",
                    method: "post",
                    data: values,
                    success: function (data) {
                        if (callback) {
                            callback(selector, data);
                        }
                        hideLoading();

                    },
                    error: (data) => {
                      hideLoading();
                      const mMessage = new Monet.Form.Messages.AlertMessage();
                      mMessage.setMessage(JSON.parse(data.responseText));
                      mMessage.triggerMessage();
                      this.refreshAllRoutes();
                    }
                });
                request.send();

            } catch (e) {

                var error = new Monet.Exception.ReturnError(this, "Problem on request transfer stops.");
                error.console();

            }

        }

    };

    this.deleteStop = function (stopId, callback, selector) {

        try {
            showLoading();
            const request = new DefaultRequest({
                url: "Stop/" + stopId,
                method: "delete",
                success: function (data) {

                    callback(data);
                    hideLoading();

                },
                error: (data) => {
                  hideLoading();
                  const mMessage = new Monet.Form.Messages.AlertMessage();
                  mMessage.setMessage(JSON.parse(data.responseText));
                  mMessage.triggerMessage();
                  this.refreshRouteBySelectorId(selector);
                }
            });
            request.send();


        } catch (e) {
            var error = new Monet.Exception.ReturnError(this, "Error on request delete de stops.", e);
            error.console();
        }
    };

  this.getStopsAndAddToList = (filter, selector) => {
    const eventsToOrderStops = new Greenmile.Route.TransferStops.EventsToSort();
    this.getRouteDataByFilter(filter, eventsToOrderStops.addStopsToList, selector);
  };

  this.refreshRouteBySelectorId = (selectorId) => {
    const [routeToUpdate] = /stopsRouteSelected|stopsRouteFiltered/.exec(selectorId);
    this.getStopsAndAddToList(Monet.Session.TransferStops[routeToUpdate].filter, selectorId);
  };

  this.refreshAllRoutes = () => {
    const { stopsRouteSelected, stopsRouteFiltered } = Monet.Session.TransferStops;
    this.getStopsAndAddToList(stopsRouteSelected.filter, '#stopsRouteSelected');
    this.getStopsAndAddToList(stopsRouteFiltered.filter, '#stopsRouteFiltered');
  };
};
